<template>
  <div class="l-err-message">
    <div class="err-message-background"></div>
    <div class="err-message-container">
      <!-- If you want use this icon close in dialog. Open code below -->
      <!-- <a class="close-popup" @click="close()">
        <img src="../assets/img/buttons/small.png" alt="ico_close">
      </a> -->
      <div class="content">
        <p>データの更新に失敗しました。</p>
        <p>通信状況の良いところで、再度お試しください。</p>
      </div>
      <div class="btn-actions">
        <c-button-border :msg="btnValue" :class="'center'" :actionClick="this.handleLoadingScreen"></c-button-border>
      </div>
    </div>
  </div>
</template>
<script>
import CButtonBorder from '@/components/CButtonBorder.vue'

import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'ErrorMessage',
  components: {
    CButtonBorder
  },
  data: function () {
    return {
      btnValue: null
    }
  },
  props: {
    id: null,
    isUsed: null,
    typeProp: null
  },
  async created () {
    document.title = this.$options.name
    this.btnValue = this.isUsed ? 'もう一度試す​' : 'データを取得する'
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    handleLoadingScreen: function () {
      try {
        this.trackEvent(FactoryTrack.createErrorRetry())
        if (typeof window.Android !== 'undefined' && window.Android !== null) {
          if (this.isUsed) {
            // exchangePrize()
            window.Android && window.Android.reConnectCountTimer(this.id, true)
          } else {
            window.Android && window.Android.reConnectCouponDetail(this.id)
          }
        } else {
          if (this.isUsed) {
            this.$router.push({ name: 'LoadingScreen', params: { callback: this.handleCountTimer, lastView: 'Coupon' } })
          } else {
            this.$router.push({ name: 'LoadingScreen', params: { callback: this.handleCouponClick, lastView: 'Coupon' } })
          }
        }
      } catch (err) {
        console.log(err + 'method: handleLoadingScreen')
      }
    },
    handleCouponClick: function () {
      if (this.id) {
        this.$router.push({ path: '/coupon/' + this.id })
      }
    },
    handleCountTimer: function () {
      if (this.id) {
        this.$router.push({ path: '/coupon/' + this.id, query: { isUsed: true } }) // type: this.typeProp
      }
    },
    close: function () {
      try {
        this.trackEvent(FactoryTrack.createClose())
        if (typeof window.Android !== 'undefined' && window.Android !== null) {
          window.Android && window.Android.closeUseDetail()
        } else {
          this.$router.push({ name: 'Coupon' })
        }
      } catch (err) {
        console.log(err + 'method: close')
      }
    }
  }
}
</script>
<style scoped>
.l-err-message .err-message-background {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  opacity: 0.6;
  filter: alpha(opacity=60); /* For IE8 and earlier */
  background-color: #ffffff;
}
.l-err-message .err-message-container {
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
  border: solid 1px #cccccc;;
  background-color: #ffffff;
  min-width: 200px;
  width: 80%;
  min-height: auto;
  padding-top: 50px;
  padding-bottom: 50px;
  border-radius: 16px
}
.l-err-message .err-message-container.err-message-message-only-title {
  min-height: 400px;
}
.l-err-message .err-message-container .content {
  width: auto;
  padding-right: 20px;
  padding-left: 20px;
  margin: auto;
  margin-top: 0px;
  font-size: 12px;
  line-height: 2;
  letter-spacing: 0;
  text-align: center;
  color: #000000;
}
.l-err-message .err-message-container .btn-actions {
  margin-top: 40px;
}
.l-err-message .err-message-container .btn-actions .c_button_border {
  font-size: 16px;
  width: 80%;
  height: 45px;
  background-color: #602209;
  color: #ffffff;
  border-radius: 10px;
  border: none;
}

.l-err-message .err-message-container .close-popup > img {
  position: fixed;
  top: -26px;
  right: -8px;
  padding: 15px;
  background-color: #ffffff;
  border-radius: 100%;
  border: 1px solid #eeeeee;
}

</style>
